$( function () {

    $('button[name="send"]', '.chat-window').on('click', send_message);

    //$('input[name="message"]').on('keyup', function(e){
    //    var code = e.which; // recommended to use e.which, it's normalized across browsers
    //    console.log(code);
    //    // if code == 13 then submit
    //});

    $('input[name="message"]', '.chat-window').on('focus', function(){ // ook op keydown doen?
        $('.msg_sent.unread').removeClass('unread');
    });

    function send_message(e){
        e.preventDefault();

        var form = $(this).parents('form');

        if($('input[name="message"]', form).val() == ''){
            return false;
        }

        $('input[name="message"]', form).attr('disabled', true);
        $('button[name="send"]').attr('disabled', true);

        $.post("/message/send",
            {
                '_token': $('input[name="_token"]', form).val(),
                '_user_id': $('input[name="_user_id"]', form).val(),
                'message': $('input[name="message"]', form).val(),
            },
            function (response) {

                $('input[name="message"]', form).val('').attr('disabled', false).focus();
                $('button[name="send"]').attr('disabled', false);

                if (response.success == false) {
                    systemalert(response.message, 'warning');
                }

            }.bind(this),
            'json'
            )
            .fail(function () {
                $(this).attr('disabled', false);
                systemalert('There was an system error, please notify an admin!', 'danger');
            })

    }

});

$( function () {
    $('a.open-chatwindow').on('click', open_chatwindow);
    $('.open_now', '.chat-users-window').find('a.open-chatwindow').trigger('click');

    function open_chatwindow(e){
        e.preventDefault();

        // remove unreaded stage
        var user_row = $(this).parents('.row');
        user_row.removeClass('has-new-messages');
        $('span.latest-message', user_row).text('');

        if($('.nochatwindow').is(':visible')) {
            $('.nochatwindow').slideUp();
            $('.chatwindow').hide().removeClass('hide').slideDown();
        }

        var user_id = $(this).attr('data-user');

        $.get("/message/chat",
            {
                '_user_id': user_id
            },
            function (response) {

                if (response.success == true) {

                    $('.msg_container_name').text(response.data.friend.name);
                    $('input[name="_user_id"]').val(response.data.friend.id);

                    $('.msg_container_base').html('');

                    if(response.data.count > 0) {
                        $.each(
                            response.data.messages,
                            function(key, message){
                                $('.msg_container_base').append(
                                    message
                                );
                            }
                        );

                        if(($('.badge_message').text() - response.data.count_unread) > 0) {
                            $('.badge_message').text($('.badge_message').text() - response.data.count_unread);
                        } else {
                            $('.badge_message').remove();
                        }
                    }

                    $('.msg_container_base').scrollTop(
                        $('.msg_container_base').prop('scrollHeight')
                    );

                } else {
                    systemalert('The chat could not be loaded', 'warning');
                }

                $(this).attr('disabled', false);
            }.bind(this),
            'json'
            )
            .fail(function () {
                $(this).attr('disabled', false);
                systemalert('There was an system error, please notify an admin!', 'danger');
            })
    }

});